import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrEmptyString } from '../../../../shared/utils.js';
import { isNullOrUndefined } from 'util';
import { CLPUser, clpUserDefaults, CLPUserProfile, UserDD, UserDefaultLoadResponse, UserResponse } from '../../../models/clpuser.model';
import { ClpCompany } from '../../../models/company.model';
import { Contact, ContactList } from '../../../models/contact.model';
import { eFeatures, eMailingCategory, eMailingFromType, eMailingSalutation, eMailingStatus, eMailingToType, eTxtMsgStatus, eUserRole } from '../../../models/enum.model';
import { SimpleResponse } from '../../../models/genericResponse.model';
import { EngageImageDocument } from '../../../models/imageDocument.model';
import { Mailing } from '../../../models/mailing.model';
import { MailingContact } from '../../../models/mailingContact.model';
import { RoleFeaturePermissions } from '../../../models/roleContainer.model';
import { Search, SearchListResponse, SearchQueryResponse } from '../../../models/search.model';
import { TxtMsgTemplate } from '../../../models/textMsgTemplate.model';
import { MailingTxtMsgSaveRequest, TxtMsg, TxtMsgBulk, TxtMsgMailingFilterResponse, TxtMsgSettings } from '../../../models/txtMsg.model';
import { ContactService } from '../../../services/contact.service';
import { NotificationService } from '../../../services/notification.service';
import { SearchContactService } from '../../../services/Searchcontact.service';
import { ContactSearchService } from '../../../services/shared/contact-search.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TextMsgTemplateService } from '../../../services/text-msg-template.service';
import { TxtMsgService } from '../../../services/textmsg.service';
import { UserService } from '../../../services/user.service';
import { GlobalService } from '../../../services/global.service';
import { EmailBlastService } from '../../../services/email-blast.service';
import { BWCampaign, BWCampaignListResponse } from '../../../models/bw-campaign.model';
import { CLPEnvironmentService } from '../../../services/clp-environment.service';
import { EmailDetails } from '../../../models/email.model';

@Component({
    selector: 'app-text-campaign',
    templateUrl: './text-campaign.component.html',
    styleUrls: ['./text-campaign.component.css']
})
export class TextCampaignComponent {
    eUserRole = eUserRole;
    isProcess: boolean = false;
    showSpinner: boolean = false;
    userProfileData: CLPUserProfile;
    queryDataLoaded: SearchQueryResponse = <SearchQueryResponse>{};
    mailingTeamCode: number = 0;
    roleFeaturePermissions: RoleFeaturePermissions;
    user: CLPUser;
    private encryptedUser: string = '';
    mailingCLPUserId: number;
    lablmsg: string = '';
    userResponse: UserResponse;
    gridHeight;
    txtMsgMailingFilterResponse: TxtMsgMailingFilterResponse;
    step: number = 1;
    isSlurrpy: boolean = false;
    movedDirectMailData: ContactList[] | Contact[] = [];
    lblWhatsLeftTxt: string = "";
    promoText: string = "";
    textCampaignData: Mailing = <Mailing>{};
    textCampaignForm: FormGroup;
    textMsgTemplateList: TxtMsgTemplate[];
    imageDocumentList: EngageImageDocument[];
    sendTestData: TxtMsg | TxtMsgBulk = <TxtMsg>{};
    scheduleTextData: MailingTxtMsgSaveRequest = <MailingTxtMsgSaveRequest>{};
    isPreview: boolean = false;
    labelMsgBox: boolean = false;
    msgTxtBox: boolean = true;
    messageBody: string = '';
    mediaUrl: string = '';
    selImageText: string = 'Select Images';
    contactSearchList: Search[] = [];
    dateFormat: string = "MM/dd/yyyy";
    contact: Contact;
    contactId: number = 0;
    sendTestStr: string = "";
    warningString: string[] = [];
    contactIdForConnection: number = 0;
    mailingId: number = 0;
    isShowWarning: boolean = false;
    warningMsg: string = "";
    isShowWarningMsg: boolean = false;
    campaignOwner: UserDD[] = [];
    txtMsgSettingsData: TxtMsgSettings = <TxtMsgSettings>{};
    companyData: ClpCompany = <ClpCompany>{};
    isShowVDLink: boolean = false;
    customSearchId: number = 0;
    isJim: boolean = false;
    today: Date = new Date();
    //public min: Date = new Date(0, 0, 0, 8, 30);
    //public max: Date = new Date(0, 0, 0, new Date().getDate(), 22);
    public steps: any = {
        year: 0,
        month: 0,
        day: 0,
        hour: 0,
        minute: 15,
        second: 0,
        millisecond: 0,
    };
    txtMsgSettings: TxtMsgSettings = <TxtMsgSettings>{};
    bWCampaignListResponse: BWCampaignListResponse;
    campaignListDD: BWCampaign[];
    isShowSetCampaign: boolean = false;
    userDefaultLoad: UserDefaultLoadResponse;
    clpUserDefaults: clpUserDefaults;
    activeHours: string = '';
    tnCampaignResponse: SimpleResponse;
    brandResponse: SimpleResponse;
    lblBWBrand2: string = '';
    campaignId: string = '0'
    btnEditCampaign: string = 'Campaign not set';
    showTemplateList: boolean = false;
    userLocalTime: Date = new Date();
    selectedOwner: string = '';

    BWCampaignToSet: string = '';
    BWBrandToSet: string = '';
    timeSlots = [
        { value: '8:30 AM', text: '8:30 AM' },
        { value: '8:45 AM', text: '8:45 AM' },
        { value: '9:00 AM', text: '9:00 AM' },
        { value: '9:15 AM', text: '9:15 AM' },
        { value: '9:30 AM', text: '9:30 AM' },
        { value: '9:45 AM', text: '9:45 AM' },
        { value: '10:00 AM', text: '10:00 AM' },
        { value: '10:15 AM', text: '10:15 AM' },
        { value: '10:30 AM', text: '10:30 AM' },
        { value: '10:45 AM', text: '10:45 AM' },
        { value: '11:00 AM', text: '11:00 AM' },
        { value: '11:15 AM', text: '11:15 AM' },
        { value: '11:30 AM', text: '11:30 AM' },
        { value: '11:45 AM', text: '11:45 AM' },
        { value: '12:00 PM', text: 'Noon' },
        { value: '12:15 PM', text: '12:15 PM' },
        { value: '12:30 PM', text: '12:30 PM' },
        { value: '12:45 PM', text: '12:45 PM' },
        { value: '1:00 PM', text: '1:00 PM' },
        { value: '1:15 PM', text: '1:15 PM' },
        { value: '1:30 PM', text: '1:30 PM' },
        { value: '1:45 PM', text: '1:45 PM' },
        { value: '2:00 PM', text: '2:00 PM' },
        { value: '2:15 PM', text: '2:15 PM' },
        { value: '2:30 PM', text: '2:30 PM' },
        { value: '2:45 PM', text: '2:45 PM' },
        { value: '3:00 PM', text: '3:00 PM' },
        { value: '3:15 PM', text: '3:15 PM' },
        { value: '3:30 PM', text: '3:30 PM' },
        { value: '3:45 PM', text: '3:45 PM' },
        { value: '4:00 PM', text: '4:00 PM' },
        { value: '4:15 PM', text: '4:15 PM' },
        { value: '4:30 PM', text: '4:30 PM' },
        { value: '4:45 PM', text: '4:45 PM' },
        { value: '5:00 PM', text: '5:00 PM' },
        { value: '5:15 PM', text: '5:15 PM' },
        { value: '5:30 PM', text: '5:30 PM' },
        { value: '5:45 PM', text: '5:45 PM' },
        { value: '6:00 PM', text: '6:00 PM' },
        { value: '6:15 PM', text: '6:15 PM' },
        { value: '6:30 PM', text: '6:30 PM' },
        { value: '6:45 PM', text: '6:45 PM' },
        { value: '7:00 PM', text: '7:00 PM' },
        { value: '7:15 PM', text: '7:15 PM' },
        { value: '7:30 PM', text: '7:30 PM' },
        { value: '7:45 PM', text: '7:45 PM' },
        { value: '8:00 PM', text: '8:00 PM' },
        { value: '8:15 PM', text: '8:15 PM' },
        { value: '8:30 PM', text: '8:30 PM' },
        { value: '8:45 PM', text: '8:45 PM' },
        { value: '9:00 PM', text: '9:00 PM' },
        { value: '9:15 PM', text: '9:15 PM' },
        { value: '9:30 PM', text: '9:30 PM' },
        { value: '9:45 PM', text: '9:45 PM' },
        { value: '10:00 PM', text: '10:00 PM' },
    ];
    constructor(
        public _contactService: ContactService,
        public datepipe: DatePipe,
        private _textMsgTemplateService: TextMsgTemplateService,
        private _utilityService: UtilityService,
        private _userService: UserService,
        private _notifyService: NotificationService,
        public _localService: LocalService,
        private srchContactSrvc: SearchContactService,
        private _txtMsgSettingSrvc: TxtMsgService,
        private _globalService: GlobalService,
        private _emailBlastService: EmailBlastService,
        private fb: FormBuilder,
        private _clpEnv: CLPEnvironmentService,
        private _router: Router,
        public _contactSearchService: ContactSearchService) {
        this._localService.isMenu = true;

    }

    ngOnInit() {
        this.textCampaignForm = this.prepareTextCampaignForm();
        this._globalService.getToken((token) => {
            if (token) {
                this.encryptedUser = token;
                this.authenticateR().then(() => {
                    if (this.user) {
                        this.dateFormat = this.user.dateFormat;
                        this.mailingCLPUserId = this.user?.cLPUserID;
                        if (this.user?.cLPCompanyID == 0 || this.user?.slurpyUserId > 0) {
                            this.isShowVDLink = true;
                            this.isSlurrpy = true;
                            this.getCampaignDD();
                            this.getTxtMsgMailingBlastFilter();
                            this.getUserDefaults(this.user?.cLPUserID);
                        } else
                            this._router.navigateByUrl(`/home?msg=unauth`);

                    }
                    else
                        this._router.navigate(['/login']);
                })
            }
            else
                this._router.navigate(['/login']);
        })
    }

    async getTxtMsgMailingBlastFilter() {
        await this._txtMsgSettingSrvc.getTxtMsgMailingBlastFilter(this.encryptedUser, this.user?.cLPCompanyID, this.user.cLPUserID, this.user?.slurpyUserId)
            .then(async (result: TxtMsgMailingFilterResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    if (response?.messageString != "Unauthorize!!!") {
                        const dtApiDefaultSchedule = new Date(response.dt);
                        this.textCampaignForm.get('timeValue').setValue(this._localService.getNextTimeSlot(dtApiDefaultSchedule));
                        this.textCampaignForm.get('launchTime').setValue(new Date(dtApiDefaultSchedule.getFullYear(), dtApiDefaultSchedule.getMonth(), dtApiDefaultSchedule.getDate(), dtApiDefaultSchedule.getHours(), dtApiDefaultSchedule.getMinutes()));
                        this.warningMsg = response.messageString;
                        this.txtMsgMailingFilterResponse = response;
                        this.textMsgTemplateList = this.txtMsgMailingFilterResponse.txtMsgTemplate;
                        this.showTemplateList = this.textMsgTemplateList.length > 0 ? true : false;
                        this.imageDocumentList = this.txtMsgMailingFilterResponse.mediaImages;
                        this.campaignOwner = this.txtMsgMailingFilterResponse.ddCLPUser;
                        this.txtMsgSettings = this.txtMsgMailingFilterResponse.txtMsgSettings;
                        if (!this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD)
                            this.mailingCLPUserId = this.user?.cLPUserID;
                        this.textCampaignForm.get("isPromo").setValue(true);
                        if (!isNullOrEmptyString(this.txtMsgSettings?.sMSPromoComplianceApend)) {
                            this.promoText = "<span style='font-weight: bold; color: darkred;'>" + this.txtMsgSettings?.sMSPromoComplianceApend + "</span>" + "will be appended to each message.";
                            this.lblWhatsLeftTxt = ((500 - this.txtMsgSettings?.sMSPromoComplianceApend.length - 5) - +this.textCampaignForm.controls.message.value) + ' chars left';
                        }
                        if (!isNullOrUndefined(this.warningMsg) && this.warningMsg != "")
                            this.isShowWarningMsg = true;
                        else
                            this.isShowWarningMsg = false;
                    } else {
                        this._router.navigateByUrl(`/home?msg=unauth`);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.getTxtMsgMailingBlastFilter", err.message, null, 'cLPCompanyID ' + this.user?.cLPCompanyID + 'cLPUserID ' + this.user.cLPUserID + 'slurpyUserId ' + this.user?.slurpyUserId);
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async authenticateR() {
        this.showSpinner = true;
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.CreateNewTextBlastMailing)
            .then(async (result: UserResponse) => {
                if (result) {
                    await this._localService.checkIfExpiredOrUnauthorized(result?.user);
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigateByUrl(`/home?msg=unauth`);
                            }
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.authenticateR", err.message, null, 'Features ' + eFeatures.CreateNewTextBlastMailing);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    prepareTextCampaignForm() {
        const urlRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
        return this.fb.group({
            launchTime: new FormControl(new Date()),
            businessDay: new FormControl(false),
            isPromo: new FormControl(false),
            campaignOwner: new FormControl(0),
            fromNumber: new FormControl(0),
            fromType: new FormControl(0),
            txtMsgTemplateID: new FormControl(0),
            documentId: new FormControl(0),
            medialUrl: new FormControl('', [Validators.required, Validators.pattern(urlRegex)]),
            message: new FormControl(''),
            timeValue: new FormControl('8:30 AM')
        })
    }

    async sendTest() {
        this.showSpinner = true;
        this.copySendTestData();
        await this._textMsgTemplateService.sendTest(this.encryptedUser, this.sendTestData as TxtMsg)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this._notifyService.showSuccess(response.messageString ? response.messageString : "Test text message has been scheduled.", "", 3000);
                    this.showSpinner = false;
                }
                else
                    this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.sendTest", err.message, null, 'TxtMsg ' + this.sendTestData);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    setTemplateHtml(id) {
        if (!isNullOrUndefined(id)) {
            switch (id) {
                case "":
                    break;
                case "0":
                    this.txtMsgMailingFilterResponse.isShowMessageTxt = true;
                    this.textCampaignForm.get('message').setValue("");
                    this.lblWhatsLeftTxt = (500 - this.textCampaignForm.get('message').value).toString() + " chars left";
                    break;
                case "-1":
                    this.textCampaignForm.get('message').setValue("PH_ContactFromDirectionsURL");
                    this.txtMsgMailingFilterResponse.isShowMessageTxt = true;
                    if (this.txtMsgMailingFilterResponse.isAllowFreeForm) {
                        this.msgTxtBox = true;
                        this.labelMsgBox = false;
                    } else {
                        this.lablmsg = "PH_ContactFromDirectionsURL";
                        this.msgTxtBox = false;
                        this.labelMsgBox = true;
                    }
                    this.lblWhatsLeftTxt = (500 - this.textCampaignForm.get('message').value).toString() + " chars left";
                    break;
                case "-2":
                    this.textCampaignForm.get('message').setValue("PH_ContactToDirectionsURL");
                    this.txtMsgMailingFilterResponse.isShowMessageTxt = true;
                    if (this.txtMsgMailingFilterResponse.isAllowFreeForm) {
                        this.msgTxtBox = true;
                        this.labelMsgBox = false;
                    } else {
                        this.lablmsg = "PH_ContactToDirectionsURL";
                        this.msgTxtBox = false;
                        this.labelMsgBox = true;
                    }
                    this.lblWhatsLeftTxt = (500 - this.textCampaignForm.get('message').value).toString() + " chars left";
                    break;
                default:
                    var selectedTxtMsg: TxtMsgTemplate = <TxtMsgTemplate>{};
                    selectedTxtMsg = this.textMsgTemplateList.filter(item => item.txtMsgTemplateID == id)[0]
                    if (!isNullOrUndefined(selectedTxtMsg) && selectedTxtMsg.txtMsgTemplateID > 0) {
                        this.textCampaignForm.get('message').setValue(selectedTxtMsg.messageText);
                        this.textCampaignForm.get('medialUrl').setValue(selectedTxtMsg.mediaURL);
                        this.txtMsgMailingFilterResponse.isShowMessageTxt = true;
                        if (this.txtMsgMailingFilterResponse.isAllowFreeForm) {
                            this.msgTxtBox = true;
                            this.labelMsgBox = false;
                        } else {
                            this.lablmsg = selectedTxtMsg.messageText;
                            this.msgTxtBox = false;
                            this.labelMsgBox = true;
                        }

                    }
                    this.lblWhatsLeftTxt = (500 - this.textCampaignForm.get('message').value).toString() + " chars left";
                    break;
            }

        }
    }

    onChangeMedia(docId) {
        docId = this.textCampaignForm.controls.documentId.value;
        if (!isNullOrUndefined(docId)) {
            var doc = this.imageDocumentList.filter(item => item.documentId == docId)[0];
            if (!isNullOrUndefined(doc)) {
                if (!isNullOrUndefined(doc.imagePath))
                    this.textCampaignForm.get('medialUrl').setValue(doc.imagePath);
                this.selImageText = doc.documentName ? doc.documentName : 'Select Images';

            }
        }
    }

    async getUserLocalTime(clpUserID: number) {
        await this._userService.getUserLocalTime(this.encryptedUser, clpUserID)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    var response = UtilityService.clone(result);
                    this.userLocalTime = response?.dt;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("user-setup.checkuserNameDuplicate", err.message, 'clpUserID ' + clpUserID);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    parseTime(timeStr: string) {
        const [time, modifier] = timeStr.trim().split(" ");
        let [hours, mins] = time.split(":").map(Number);

        if (modifier === 'PM' && hours < 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;

        return { hours, mins };
    }

    async configure() {
        var sb: string[] = [];
        if (isNullOrEmptyString(this.textCampaignForm.controls.message.value)) {
            sb.push('Please enter a message.');
        } else {
            var intTotalLength: number = this.textCampaignForm.controls.message.value;
            if (this.textCampaignForm.controls.isPromo.value) {
                if (!isNullOrEmptyString(this.txtMsgSettings?.sMSPromoComplianceApend))
                    intTotalLength += this.txtMsgSettings?.sMSPromoComplianceApend?.length;
            } else {
                if (!isNullOrEmptyString(this.txtMsgSettings?.sMSInfoComplianceApend))
                    intTotalLength += this.txtMsgSettings?.sMSInfoComplianceApend?.length;
            }
            if (intTotalLength > 500)
                sb.push('The character limit of 500 has been exceeded.  Please shorten the message.');
        }
        if (isNullOrEmptyString(this.textCampaignForm.controls.medialUrl.value)) {
            sb.push('Please enter a Media URL. It needs to be a hyperlink to an image.');
        }
        if (!isNullOrEmptyString(this.textCampaignForm.controls.medialUrl.value) && (this.textCampaignForm.controls.medialUrl.value.startsWith("http") == false)) {
            sb.push('Please check the Media URL. It needs to be a hyperlink to an image.');
        }
        if (this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD && +this.textCampaignForm.controls.campaignOwner.value <= 0) {
            sb.push('Please select a user for this campaign.');
        }

        let launchDate = new Date(this.textCampaignForm.controls.launchTime.value);
        let timeStr = this.textCampaignForm.controls.timeValue.value;

        const { hours, mins } = this.parseTime(timeStr);

        let firstDate: any = new Date(
            launchDate.getFullYear(),
            launchDate.getMonth(),
            launchDate.getDate(),
            hours,
            mins
        );

        //let firstDate: any = new Date(new Date(this.textCampaignForm.controls.launchTime.value).getFullYear(), new Date(this.textCampaignForm.controls.launchTime.value).getMonth(),
        //    new Date(this.textCampaignForm.controls.launchTime.value).getDate(), new Date(this.textCampaignForm.controls.timeValue.value).getHours(), new Date(this.textCampaignForm.controls.timeValue.value).getMinutes());

        await this.getUserLocalTime(this.user?.cLPUserID);
        let secondDate: any = new Date(this.userLocalTime);
        let difference = firstDate - secondDate;
        let minutes = Math.floor(difference / 1000 / 60);
        if (minutes < 0) {
            sb.push('Please schedule a time in the future.');
        }

        if (sb.length == 0) {
            this.isPreview = true;
            this.isShowWarning = false;
            this.mailingCLPUserId = this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD ? this.textCampaignForm.controls.campaignOwner.value : this.user.cLPUserID;

            if (+this.textCampaignForm.controls.fromType.value == eMailingFromType.MailingOwner) {

                await this.getUserProfile(this.mailingCLPUserId);

                var strTN: string;
                strTN = this.userProfileData?.txtMsgLongCode;
                if (+this.textCampaignForm.controls.fromNumber.value == 2 && !isNullOrEmptyString(this.userProfileData?.TxtMsgTollFree)) {
                    strTN = this.userProfileData?.TxtMsgTollFree;
                }

                if (strTN != '') {
                    await this.getTNCampaignBrand(strTN);
                }
                else {
                    this.lblBWBrand2 = `No From number detected ${this.userProfileData?.firstName} ${this.userProfileData?.lastName}.)`;
                }

                this.getUserDefaults(this.mailingCLPUserId);

                const SMSStartTimeWeekend = new Date(this.clpUserDefaults?.sMSStartTimeWeekend);
                const SMSEndTimeWeekend = new Date(this.clpUserDefaults?.sMSEndTimeWeekend);
                const SMSStartTimeWeekDay = new Date(this.clpUserDefaults?.sMSStartTimeWeekDay);
                const SMSEndTimeWeekDay = new Date(this.clpUserDefaults?.sMSEndTimeWeekDay);

                const selectedDate = this.textCampaignForm.controls.launchTime.value;
                const selectedTime = this.textCampaignForm.controls.timeValue.value;
                let selectedDateTime = new Date();
                if (selectedDate && selectedTime) {
                    const parsedTime = this.parseTime12HourFormat(selectedTime);

                    if (parsedTime) {
                        selectedDateTime = new Date(
                            selectedDate.getFullYear(),
                            selectedDate.getMonth(),
                            selectedDate.getDate(),
                            parsedTime.hours,
                            parsedTime.minutes,
                            0
                        );
                    } else {
                        console.warn('Invalid time format:', selectedTime);
                    }
                }

                const dayOfWeek = selectedDateTime.getDay();

                switch (dayOfWeek) {
                    case 0:
                        this.activeHours = `${SMSStartTimeWeekend.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })} to ${SMSEndTimeWeekend.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}`;
                        break;
                    default:
                        this.activeHours = `${SMSStartTimeWeekDay.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })} to ${SMSEndTimeWeekDay.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}`;
                        break;
                }
            }
            this.mediaUrl = this.textCampaignForm.controls.medialUrl.value;
            this.mediaUrl = this.textCampaignForm.controls.medialUrl.value;
            this.messageBody = this.textCampaignForm.controls.message.value;
        } else {
            this.warningString = sb;
            this.isShowWarning = true;
            this.isPreview = false;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    parseTime12HourFormat(timeStr: string): { hours: number, minutes: number } | null {
        const timeRegex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
        const match = timeStr.match(timeRegex);

        if (!match) return null;

        let hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        const meridiem = match[3].toUpperCase();

        if (meridiem === 'PM' && hours !== 12) {
            hours += 12;
        } else if (meridiem === 'AM' && hours === 12) {
            hours = 0;
        }

        return { hours, minutes };
    }

    async getContactId(value, str: string = "") {
        if (this.contactSearchList?.length > 0) {
            if (str == "connection") {
                this.contactIdForConnection = value != "" ? (parseInt(this.contactSearchList.find(item => item.searchText === value)?.searchValue)) : 0;
            } else {
                this.contactId = parseInt(this.contactSearchList.find(item => item.searchText === value)?.searchValue);
                if (this.contactId)
                    await this.getContact(this.contactId);
                if (+this.textCampaignForm.controls.fromType.value == eMailingFromType.MailingOwner)
                    await this.getUserProfile(this.mailingCLPUserId);
                else
                    await this.getUserProfile(this.contact?.cLPUserID);
                var strFromNumber: string;
                strFromNumber = this.userProfileData?.txtMsgLongCode;
                if (+this.textCampaignForm.controls.fromNumber.value == 2 && !isNullOrEmptyString(this.userProfileData?.TxtMsgTollFree))
                    strFromNumber = this.userProfileData?.TxtMsgTollFree;
                this.sendTestStr = "The test message will be sent from " + this.userProfileData?.firstName + ' ' + this.userProfileData?.lastName + ' : ' + this._localService.maskNumbersInString(strFromNumber, this.user) + " to " + this._localService.maskNumbersInString(this.contact?.mobile, this.user);
            }
        }
    }

    getSearchData(txt, value: string = "") {
        let Search: Search = <Search>{};
        Search.searchText = txt;
        Search.searchValue = "";
        this.getContactSearch(Search);
    }

    async getContact(contactId) {
        await this._contactService.contactLoad(this.encryptedUser, contactId)
            .then(async (result: Contact) => {
                if (!isNullOrUndefined(result)) {
                    var res = UtilityService.clone(result);
                    this.contact = res;
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.getContact", err.message, null, 'contactId ' + contactId);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getUserProfile(userId: number) {
        await this._userService.getUserByUserId(this.encryptedUser, userId)
            .then(async (result: CLPUserProfile) => {
                if (!isNullOrUndefined(result)) {
                    this.userProfileData = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.getUserProfile", err.message, null, 'userId ' + userId);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getContactSearch(searchData: Search) {
        this.srchContactSrvc.getContactSearchData(this.encryptedUser, this.user?.cLPUserID, searchData)
            .then(async (result: SearchListResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.contactSearchList = response.searchList.filter(i => i.searchValue.includes("ct"));
                    for (var i = 0; i < this.contactSearchList.length; i++) {
                        this.contactSearchList[i].searchValue = this.contactSearchList[i].searchValue.split("ct")[1]
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("text-campaign.getContactSearch", err.message, searchData, 'cLPUserID ' + this.user?.cLPUserID);
                this._utilityService.handleErrorResponse(err);
            });
    }

    goBack(currentStep: number) {
        switch (currentStep) {
            case 2:
                this.step = 1;
                break;
            case 3:
                this.step = 2;
                break;
        }
    }

    goToNext(id) {
        switch (id) {
            case 1:
                this.step = 2;
                break;
            case 2:
                this.copyTextCampaignFormValue();
                this.step = 3;
                break;
            case 3:
                this.schduleTextMsg();
                this.step = 4;
                break;
            default:
                break;
        }
    }

    async schduleTextMsg() {
        this.showSpinner = true
        var mailingTxtMsgSaveRequest: MailingTxtMsgSaveRequest = <MailingTxtMsgSaveRequest>{};
        mailingTxtMsgSaveRequest.mailingClpUserId = this.mailingCLPUserId;
        mailingTxtMsgSaveRequest.clpCompanyId = this.user?.cLPCompanyID;
        mailingTxtMsgSaveRequest.clpUserId = this.user?.cLPUserID;
        mailingTxtMsgSaveRequest.slurrpyUserId = this.user?.slurpyUserId;
        mailingTxtMsgSaveRequest.isSlurrpy = this.isSlurrpy;
        mailingTxtMsgSaveRequest.isOverride = this.textCampaignForm.controls.businessDay.value;
        mailingTxtMsgSaveRequest.message = this.textCampaignForm.controls.message.value;

        let launchDate = new Date(this.textCampaignForm.controls.launchTime.value);
        let timeStr = this.textCampaignForm.controls.timeValue.value;

        const { hours, mins } = this.parseTime(timeStr);

        let scheduleDt: any = new Date(
            launchDate.getFullYear(),
            launchDate.getMonth(),
            launchDate.getDate(),
            hours,
            mins
        );

        //let scheduleDt: any = new Date(new Date(this.textCampaignForm.controls.launchTime.value).getFullYear(), new Date(this.textCampaignForm.controls.launchTime.value).getMonth(),
        //    new Date(this.textCampaignForm.controls.launchTime.value).getDate(), new Date(this.textCampaignForm.controls.timeValue.value).getHours(), new Date(this.textCampaignForm.controls.timeValue.value).getMinutes());

        mailingTxtMsgSaveRequest.schedulingDate = this.datepipe.transform(scheduleDt, "MMddyyyy HHmmssa");
        mailingTxtMsgSaveRequest.isPromo = this.textCampaignForm.controls.isPromo.value;
        mailingTxtMsgSaveRequest.fromNumber = this.textCampaignForm.controls.fromNumber.value;
        mailingTxtMsgSaveRequest.fromType = this.textCampaignForm.controls.fromType.value;
        mailingTxtMsgSaveRequest.mediaUrl = this.textCampaignForm.controls.medialUrl.value;

        var mailingContactList: MailingContact[] = [];
        await this.movedDirectMailData.forEach((item) => {
            var mailingContact = <MailingContact>{};
            mailingContact.contactID = item?.contactID;
            mailingContact.fromAddress = item?.address;
            mailingContact.mailingID = this.mailingId;
            mailingContactList.push(mailingContact);
        });
        mailingTxtMsgSaveRequest.contactList = mailingContactList;
        mailingTxtMsgSaveRequest.processAll = this.isProcess;
        mailingTxtMsgSaveRequest.customSearchID = this.customSearchId;
        mailingTxtMsgSaveRequest.searchQueryResponse = this.queryDataLoaded;
        await this._textMsgTemplateService.scheduleMailingTextMsg(this.encryptedUser, mailingTxtMsgSaveRequest)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.mailingId = response?.messageInt;
                    this.updateBWCampaignInfo();
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("text-campaign.schduleTextMsg", err.message, mailingTxtMsgSaveRequest);
                this._utilityService.handleErrorResponse(err);
            });
    }

    copyTextCampaignFormValue() {
        this.textCampaignData.cLPCompanyID = this.user.cLPCompanyID;
        this.textCampaignData.category = eMailingCategory.TxtMsg;
        this.textCampaignData.mailingID = 0
        this.textCampaignData.cLPUserID = this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD ? this.textCampaignForm.controls.campaignOwner.value : this.user.cLPUserID;


        if (this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD == false) {
            const fallbackUser = this.user
                ? `${this.user.firstName}, ${this.user.lastName}, ${this.user.email}`
                : null;

            this.selectedOwner =
                this.txtMsgMailingFilterResponse?.strCampaignOwner ?? fallbackUser;
        }
        else {
            this.selectedOwner =
                this.campaignOwner
                    ?.find(i => Number(i.value) === Number(this.textCampaignData?.cLPUserID))
                    ?.text ?? null;
        }


        this.textCampaignData.salutation = eMailingSalutation.None;
        if (this.txtMsgMailingFilterResponse.isSlurrpy && this.textCampaignForm.controls.businessDay.value)
            this.textCampaignData.salutation = eMailingSalutation.FirstOnly

        this.textCampaignData.subject = 'Text Campaign';
        this.textCampaignData.body = this.textCampaignForm.controls.message.value;
        this.textCampaignData.signature = this.textCampaignForm.controls.medialUrl.value;
        this.textCampaignData.documentList = "";
        this.textCampaignData.emailTemplateID = 0;
        this.textCampaignData.mailMergeTemplateID = 0;

        let launchDate = new Date(this.textCampaignForm.controls.launchTime.value);
        let timeStr = this.textCampaignForm.controls.timeValue.value;

        const { hours, mins } = this.parseTime(timeStr);

        let scheduleDt: any = new Date(
            launchDate.getFullYear(),
            launchDate.getMonth(),
            launchDate.getDate(),
            hours,
            mins
        );

        //let scheduleDt: any = new Date(new Date(this.textCampaignForm.controls.launchTime.value).getFullYear(), new Date(this.textCampaignForm.controls.launchTime.value).getMonth(),
        //    new Date(this.textCampaignForm.controls.launchTime.value).getDate(), new Date(this.textCampaignForm.controls.timeValue.value).getHours(), new Date(this.textCampaignForm.controls.timeValue.value).getMinutes());



        this.textCampaignData.strMailingStartTime = this.datepipe.transform(scheduleDt, "MMddyyyy HHmmssa");
        this.textCampaignData.mailingStartTime = scheduleDt;
        //this.textCampaignData.strMailingStartTime = this.datepipe.transform(this.textCampaignForm.controls.launchTime.value.toString(), 'MMddyyyy HHmmssa');
        this.textCampaignData.mailingTypeCode = this.textCampaignForm.controls.fromNumber.value;
        this.textCampaignData.fromType = this.textCampaignForm.controls.fromType.value;
        this.textCampaignData.toType = eMailingToType.Contact;
        this.textCampaignData.customSearchID = 0;
        this.textCampaignData.score = 0;
        this.textCampaignData.status = eMailingStatus.Completed;
    }

    copySendTestData() {
        this.sendTestData.txtMsgID = 0;
        this.sendTestData.cLPCompanyID = this.user.cLPCompanyID;
        this.sendTestData.contactID = this.contactId;
        this.sendTestData.countryCode = "1";
        this.sendTestData.isToUser = false;
        if (+this.textCampaignForm.controls.fromType.value == eMailingFromType.ContactOwner)
            this.sendTestData.cLPUserID = this.contact?.cLPUserID;
        else {
            this.sendTestData.cLPUserID = this.txtMsgMailingFilterResponse?.isShowCampaignOwnerDD && this.textCampaignForm.controls.campaignOwner.value > 0 ? this.textCampaignForm.controls.campaignOwner.value : this.user.cLPUserID;
        }

        if (+this.textCampaignForm.controls.fromNumber.value == 2) {
            if (!isNullOrEmptyString(this.user?.TxtMsgTollFree))
                this.sendTestData.fromNumber = this.user?.TxtMsgTollFree;
        }
        this.sendTestData.isUseTollFree = +this.textCampaignForm.controls.fromNumber.value == 2;
        this.sendTestData.toCLPUserID = 0;
        this.sendTestData.msg = this.textCampaignForm.controls.message.value;
        this.sendTestData.mediaURL = this.textCampaignForm.controls.medialUrl.value;
        this.sendTestData.status = eTxtMsgStatus.Pending;
        this.sendTestData.dtSend = this.datepipe.transform(new Date(), 'MM-dd-yyyy');
        this.sendTestData.campaignID = 0;
        this.sendTestData.campaignEventID = 0;
        this.sendTestData.runID = 0;
    }

    onChangePromo(value: boolean) {
        this.promoText = "";
        this.lblWhatsLeftTxt = (500 - +this.textCampaignForm.controls.message.value) + ' chars left';
        if (value) {
            if (!isNullOrEmptyString(this.txtMsgSettings?.sMSPromoComplianceApend)) {
                this.promoText = "<span style='font-weight: bold; color: darkred;'>" + this.txtMsgSettings?.sMSPromoComplianceApend + "</span>" + "will be appended to each message.";
                this.lblWhatsLeftTxt = ((500 - this.txtMsgSettings?.sMSPromoComplianceApend?.length - 5) - +this.textCampaignForm.controls.message.value) + ' chars left';
            }
        } else {
            if (!isNullOrEmptyString(this.txtMsgSettings?.sMSInfoComplianceApend)) {
                this.promoText = "<span style='font-weight: bold; color: darkred;'>" + this.txtMsgSettings?.sMSInfoComplianceApend + "</span>" + "will be appended to each message.";
                this.lblWhatsLeftTxt = ((500 - this.txtMsgSettings?.sMSInfoComplianceApend?.length - 5) - +this.textCampaignForm.controls.message.value) + ' chars left';
            }
        }
    }

    addText(value: string) {
        this.textCampaignForm.get('message').patchValue(this.textCampaignForm.controls.message.value + ' ' + value);
    }

    async getCampaignDD() {
        await this._emailBlastService.getBWCampaignDD(this.encryptedUser)
            .then(async (result: BWCampaignListResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.bWCampaignListResponse = UtilityService.clone(result);
                    this.campaignListDD = this.bWCampaignListResponse.bwCampaignList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("view-mailings.getCampaignDD", err.message);
                this._utilityService.handleErrorResponse(err);
                this.showSpinner = false;
            });
    }

    async getUserDefaults(clpUserId: number) {
        return this._userService.getUserDefaults(this.encryptedUser, clpUserId)
            .then(async (result: UserDefaultLoadResponse) => {
                if (result) {
                    this.userDefaultLoad = UtilityService.clone(result);
                    this.clpUserDefaults = this.userDefaultLoad?.clpUserDefaults;
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log('error in saving setting code' + err);
            });
    }

    async getBrand(strCampaign: string) {
        await this._emailBlastService.getBrand(this.encryptedUser, strCampaign)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                    this.brandResponse = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-mailings.getBrand", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }

    async setTNCampaign(strTN: string, strCampaign: string) {
        await this._emailBlastService.setTNCampaign(this.encryptedUser, strTN, strCampaign)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (!isNullOrUndefined(result)) {
                        this.tnCampaignResponse = <SimpleResponse>{};
                        this.tnCampaignResponse = UtilityService.clone(result);

                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-mailings.setTNCampaign", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveBWCampaign() {
        this.btnEditCampaign = '';
        if (!isNullOrUndefined(this.campaignId) && this.campaignId != '' && this.campaignId != '0') {
            let strTN: string = "";
            if (+this.textCampaignForm.controls.fromNumber.value == 0) {
                strTN = this.user?.txtMsgLongCode;
            }
            else if (+this.textCampaignForm.controls.fromNumber.value == 2 && this.user?.txtMsgLongCode != '') {
                strTN = this.user?.TxtMsgTollFree;
            }

            if (strTN != '') {
                await this.setTNCampaign(strTN, this.campaignId);

                if (!this.tnCampaignResponse?.messageString?.includes('ErrorCode>')) {
                    await this.getBrand(this.campaignId);
                    if (!this.brandResponse?.messageString?.includes('ErrorCode>')) {
                        this.btnEditCampaign = this.campaignId;
                        this.lblBWBrand2 = this.brandResponse?.messageString;
                        this.isShowSetCampaign = false;
                    }
                    else {
                        this.lblBWBrand2 = `Sunthin be trippin yo (show this to phil: ${this.brandResponse?.messageString}.`;

                    }
                }
                else {
                    this.sendAdminEmail(strTN)
                    this.lblBWBrand2 = this.tnCampaignResponse?.messageString;
                }
            }
        }
        else {
            this._notifyService.showError("Enter a campaign.", "", 3000);
        }
    }

    showCampaign() {
        this.isShowSetCampaign = true;
        this.lblBWBrand2 = '';
    }

    async syncCampaigns() {
        await this._emailBlastService.syncCampaigns(this.encryptedUser)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (!isNullOrUndefined(result)) {
                        let response: SimpleResponse = UtilityService.clone(result);

                        if (response.messageBool) {
                            this._notifyService.showSuccess('Brands and Campaigns have been synced', "", 3000);
                            this.getCampaignDD();
                            this.campaignId = '0';
                        }
                        else {
                            this._notifyService.showError("A problem occurred syncing Brands and Campaigns", "", 3000);
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-mailings.syncCampaigns", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }

    async sendAdminEmail(strTN: string, strXML = "") {
        var emailDetails: EmailDetails = <EmailDetails>{};
        emailDetails.subject = "BW Update Campaign error";
        emailDetails.message = `Txt Wiz BW Update Campaign error", $"strTN=${strTN}<br /><<br />strCampaign=${this.campaignId}<br /><<br />strWorked=${this.tnCampaignResponse.messageString}<br /><<br />${strXML}`;
        await this._clpEnv.sendAdminEmail(this.encryptedUser, emailDetails)
            .then(async (result: SimpleResponse) => {
                if (!isNullOrUndefined(result)) {
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-mailings.sendAdminEmail", err.message, emailDetails)
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getTNCampaignBrand(strTN: string) {
        await this._emailBlastService.getTNCampaignBrand(this.encryptedUser, strTN)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (!isNullOrUndefined(result)) {
                        this.tnCampaignResponse = <SimpleResponse>{};
                        this.tnCampaignResponse = UtilityService.clone(result);

                        let campaign = this.tnCampaignResponse.messageString;
                        let brand = this.tnCampaignResponse.messageString2;

                        if (campaign.indexOf("ERROR") == -1) {
                            this.btnEditCampaign = campaign;

                            if (brand != '') {
                                this.lblBWBrand2 = brand;
                                this.BWCampaignToSet = campaign;
                                this.BWBrandToSet = brand;
                            }
                        }
                        else {
                            this.lblBWBrand2 = `Sunthin be trippin yo (show this to phil: ${campaign})`;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("view-mailings.getTNCampaignBrand", err.message, null, 'mailingId ' + this.mailingId)
                this._utilityService.handleErrorResponse(err);
            });
    }

    async updateBWCampaignInfo() {
        if (this.BWCampaignToSet != '' && this.BWBrandToSet != '') {
            await this._emailBlastService.updateBWCampaignInfo(this.encryptedUser, this.mailingId, this.BWCampaignToSet, this.BWBrandToSet)
                .then(async (result: SimpleResponse) => {
                    if (!isNullOrUndefined(result) && result.messageBool) {

                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false;
                    this._globalService.error("view-mailings.updateBWCampaignInfo", err.message, null, 'mailingId ' + this.mailingId)
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }
}
